export default "__VITE_ASSET__1cca137a__"